import OverlayBase from "../overlay/OverlayBase";
import {useState} from "react";
import {validateIPv4} from "../../../util/validation";
import SvgLoader from "../../../svg/SvgLoader";
import {rpc_banPlayer} from "../rpc";
import {useSocket} from "../SocketContext";

export default function BanOverlay(props: { playerName: string, playerSteamId: string, playerIp?: string, hide: () => void }){

    const socket = useSocket()

    const [loading, setLoading] = useState<boolean>(false)

    const [steamId, setSteamId] = useState<string>(props.playerSteamId)
    const [displayName, setDisplayName] = useState<string>(props.playerName)
    const [reason, setReason] = useState<string>("")
    const [permanent, setPermanent] = useState<boolean>(false)
    const [durationValue, setDurationValue] = useState<number>(1)
    const [durationUnit, setDurationUnit] = useState<number>(86400)
    const [ipBan, setIpBan] = useState(false)
    const [ip, setIp] = useState<string>(props.playerIp ?? "")
    const [error, setError] = useState<string>("")

    const [errors, setErrors] = useState({ reason: "", duration: "", ip: "", steamId: "" })

    const handleBan = async () => {
        if (loading){
            return
        }
        setError("")
        let validationErrors = { reason: "", duration: "", ip: "", steamId: "" };
        if (!reason || !reason.trim()) {
            validationErrors.reason = "Reason is required.";
        }
        if (!permanent && !durationValue) {
            validationErrors.duration = "Duration is required.";
        }
        if (!steamId || !steamId.trim()){
            validationErrors.steamId = "Steam ID is required.";
        }

        if (ipBan){
            if (!ip){
                validationErrors.ip = "IP address is required.";
            }
            else if (!validateIPv4(ip)){
                validationErrors.ip = "Invalid IP address. Only IPv4 addresses are supported.";
            }
        }

        setErrors(validationErrors);
        if (validationErrors.reason || validationErrors.duration || validationErrors.ip || validationErrors.steamId) {
            return;
        }

        const duration = permanent ? -1 : durationUnit * durationValue;

        setLoading(true)

        // const response = await doFetch(`/api/client/players/bans?serverId=${serverId}`, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type" : "application/json"
        //     },
        //     body: JSON.stringify({
        //         steamId: props.playerSteamId,
        //         reason: reason,
        //         displayName: props.playerName,
        //         durationSeconds: duration
        //     })
        // })

        const result = await rpc_banPlayer(socket, steamId, displayName, reason, duration, ipBan ? ip : undefined)

        setLoading(false)

        if (result.success){
            props.hide()
        }
        else{
            let err = `Error: ${result.message ?? "Unknown error (-1)"}`
            if (result.message === "server_not_connected"){
                err = `The game server is not connected to RustServerTool (${err})`
            }
            else if (result.message === "server_timeout"){
                err = `The player is already banned or the game server did not respond in time (${err})`
            }
            else if (result.message === "player_invalid"){
                err = `Invalid SteamId (${err})`
            }
            setError(err);
        }

        // if (response.ok){
        //     props.hide()
        // }
        // else{
        //     let err = response.error ?? "Unknown error (-1)"
        //
        //     // Bad Gateway i.e. server not connected
        //     if (response.code === 502){
        //         err = `The game server is not connected to RustServerTool (${err})`
        //     }
        //     // Gateway timeout -> request timed out
        //     else if (response.code === 504){
        //         err = `The player is already banned or the game server did not respond in time (${err})`
        //     }
        //
        //     setError(err);
        // }
    };

    return (
        <OverlayBase hide={props.hide} w="w-[28rem]">
            <h2 className="text-xl font-semibold mb-4">{!!props.playerName ? `Ban '${props.playerName}'` : "Create Ban"}</h2>
            <div className="space-y-4">

                {!props.playerSteamId && <div>
                    <label className="block text-sm font-medium">Steam ID</label>
                    <input
                        type="number"
                        value={steamId}
                        onChange={(e) => setSteamId(e.target.value)}
                        placeholder="Enter Steam ID64"
                        className="rst-input w-full"
                    />
                    {errors.steamId && <p className="text-red-500 text-sm mt-1">{errors.steamId}</p>}
                </div>}
                {!props.playerName && <div>
                    <label className="block text-sm font-medium">Display Name (optional)</label>
                    <input
                        type="text"
                        value={displayName}
                        onChange={(e) => setDisplayName(e.target.value)}
                        placeholder="unnamed"
                        className="rst-input w-full"
                    />
                </div>}

                <div>
                    <label className="block text-sm font-medium">Reason</label>
                    <input
                        type="text"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Enter reason for ban"
                        className="rst-input w-full"
                    />
                    {errors.reason && <p className="text-red-500 text-sm mt-1">{errors.reason}</p>}
                </div>

                <div>
                    <label className="block text-sm font-medium mb-2">Ban Duration</label>
                    <div className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            checked={permanent}
                            onChange={(e) => setPermanent(e.target.checked)}
                            className="w-4 h-4"
                        />
                        <label className="text-sm">Permanent Ban</label>
                    </div>
                </div>

                <div>
                    {!permanent && <div className="flex gap-2">
                        <input
                            type="number"
                            value={durationValue}
                            onChange={(e) => setDurationValue(parseInt(e.target.value))}
                            placeholder="Enter duration"
                            className="rst-input w-2/3"
                        />
                        <select
                            value={durationUnit}
                            onChange={(e) => setDurationUnit(parseInt(e.target.value))}
                            className="rst-input w-1/3"
                        >
                            <option value="60">Minutes</option>
                            <option value="3600">Hours</option>
                            <option value="86400">Days</option>
                        </select>
                    </div>}
                    {errors.duration && <p className="text-red-500 text-sm mt-1">{errors.duration}</p>}
                </div>

                {/*{props.playerIp && <>*/}{/* No IP bans for now */}
                {/*    <div className="flex items-center gap-2">*/}
                {/*        <input*/}
                {/*            type="checkbox"*/}
                {/*            checked={ipBan}*/}
                {/*            onChange={(e) => setIpBan(e.target.checked)}*/}
                {/*            className="w-4 h-4"*/}
                {/*        />*/}
                {/*        <label className="text-sm">Ban IP Address</label>*/}
                {/*    </div>*/}
                {/*    {ipBan && (<div>*/}
                {/*        <label className="block text-sm font-medium">IP Address</label>*/}
                {/*        <input*/}
                {/*            type="text"*/}
                {/*            value={ip}*/}
                {/*            onChange={(e) => setIp(e.target.value)}*/}
                {/*            placeholder={props.playerIp}*/}
                {/*            className="w-full p-2 border rounded-lg text-neutral-800"*/}
                {/*        />*/}
                {/*        {errors.ip && <p className="text-red-500 text-sm mt-1">{errors.ip}</p>}*/}
                {/*    </div>)}*/}
                {/*</>}*/}
            </div>
            <div className="mt-6 flex flex-col items-end">
                {error && <p className="text-red-500 text-sm mb-2 text-right">{error}</p>}
                <div className="flex justify-end gap-3">
                    <button onClick={props.hide}
                            className="px-4 py-2 hover:bg-neutral-700 border border-neutral-500 rounded-lg">Cancel
                    </button>
                    <button onClick={handleBan} disabled={loading}
                            className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg disabled:bg-neutral-600 flex items-center">
                        {loading ? <SvgLoader className="size-5 text-transparent fill-white text-neutral-700 animate-spin inline" /> : "Ban"}
                    </button>
                </div>
            </div>
        </OverlayBase>
    )
}